export default {"src":"/_next/static/media/education-icon.e9465c23.svg","height":19,"width":22,"blurWidth":0,"blurHeight":0};